// extracted by mini-css-extract-plugin
export var link = "_qd-0";